export const formatPrice = (
  value: number,
  options: {
    valueIsCents?: boolean
    currencyCode?: string | null
    precise?: boolean
  } = {}
) => {
  let updatedValue = value

  if (options.valueIsCents) {
    updatedValue = value / 100
  }

  const numberFormatOptions: Record<string, any> = {
    useGrouping: true,
    minimumFractionDigits: 2,
    style: options.currencyCode === null ? 'decimal' : 'currency',
    currency: options.currencyCode || 'GBP',
    trailingZeroDisplay: options.precise ? 'auto' : 'stripIfInteger'
  }

  const numberFormat = new Intl.NumberFormat(
    options.currencyCode === 'EUR' ? 'fr-FR' : 'en-GB',
    numberFormatOptions as Intl.NumberFormatOptions
  )

  return numberFormat.format(updatedValue)
}
